import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'loginPacman',
    component: () => import(/* webpackChunkName: "loginPacman" */ '../views/loginPacman.vue'),
  },
  {
    path: '/gamePayment',
    name: 'gamePayment',
    component: () => import(/* webpackChunkName: "gamePayment" */ '../views/gamePayment/Index.vue')
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import(/* webpackChunkName: "pay" */ '../views/pay.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/aboutUs.vue')
  },
  {
    path: '/join',
    name: 'join',
    component: () => import(/* webpackChunkName: "privacyStatement" */ '../views/join.vue')
  },
  {
    path: '/games',
    name: 'games',
    component: () => import(/* webpackChunkName: "cookieStatement" */ '../views/games.vue')
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import(/* webpackChunkName: "faq" */ '../views/privacyPolicy.vue')
  },
  {
    path: '/refundPolicy',
    name: 'refundPolicy',
    component: () => import(/* webpackChunkName: "refundPolicy" */ '../views/refundPolicy.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/contact.vue')
  },
  {
    path: '/termsofUse',
    name: 'termsofUse',
    component: () => import(/* webpackChunkName: "termsofUse" */ '../views/termsofUse.vue')
  },
  {
    path: '/payHtml/Failed',
    name: 'Failed',
    component: () => import(/* webpackChunkName: "Failed" */ '../views/payHtml/Failed.vue')
  },
  {
    path: '/payHtml/Paymentlinkhasexpired',
    name: 'Paymentlinkhasexpired',
    component: () => import(/* webpackChunkName: "Paymentlinkhasexpired" */ '../views/payHtml/Paymentlinkhasexpired.vue')
  },
  {
    path: '/payHtml/Successful',
    name: 'Successful',
    component: () => import(/* webpackChunkName: "Successful" */ '../views/payHtml/Successful.vue')
  },
]

const routerRePush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return routerRePush.call(this, location).catch(error => error)
}
const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
    // if (to.meta.keepScrollPosition) {
    //   return savedPosition || { x: 0, y: 0 };
    // }
  }
})

export default router
